<template>
  <div v-if="isUserLoggedIn" class="section">
    <!-- <Permissions>
      <div class="container">
        <SubscriptionBooking />
      </div>
    </Permissions> -->
    <div class="container">
      <!-- <SubscriptionBooking v-if="!reload" /> -->
      <SubscriptionBooking />
    </div>
  </div>
</template>

<script>
// import Permissions from "@/components/Permissions.vue";
import SubscriptionBooking from "@/components/SubscriptionBooking.vue";
import { mapState } from "vuex";
import { auth } from "@/firebase";
// import LoginCard from "@/components/LoginCard.vue";

export default {
  name: "Subscription",
  components: {
    // Permissions,
    SubscriptionBooking,
    // LoginCard
  },
  data() {
    return {
      reload: false,
      visible: false,
      isUserLoggedIn: false,
    };
  },
  created() {
    // Setting orgnaizationId to session storage for child components
    // for later use. organizationId is passed from LoginCard component.
    if (this.$route.params.organizationId) {
      sessionStorage.organizationId = this.$route.params.organizationId;
      this.$store.dispatch("updateOrganizationId", sessionStorage.organizationId);
    }

    // TODO: For quick fix, remove later
    const maxUser = this.$route.query.maxUser || 1000;
    // If subscription details are in route query params,
    // Save them to Vuex store
    if (
      this.$route.query.type &&
      this.$route.query.plan &&
      this.$route.query.amount &&
      maxUser &&
      this.$route.query.maxLang &&
      this.$route.query.billInterval &&
      this.$route.query.currency
    ) {
      this.$store.commit("set_subscriptionDetails", {
        type: this.$route.query.type,
        plan: this.$route.query.plan,
        amount: this.$route.query.amount,
        maxUser: this.$route.query.maxUser,
        maxLang: this.$route.query.maxLang,
        billInterval: this.$route.query.billInterval,
        currency: this.$route.query.currency,
      });
    } else if (this.$route.query.type && this.$route.query.type === "trial") {
      this.$store.commit("set_subscriptionTrial", true);
    } else if (typeof this.subscriptionDetails === "undefined") {
      this.$buefy.toast.open({
        duration: 1000,
        message: "No subscription plan data found! Please try again.",
        type: "is-danger",
      });
      throw "File: Subscription.vue, No subscription plan data found as query params!";
    }
    console.log("File: Subscription.vue, subscriptionDetails", this.subscriptionDetails);
    this.$store.commit("set_routeTosubsPage", true);

    // let user = this.$store.getters.getCurrentUser;
    console.log("File: Subscription.vue, currentUser: ", auth);
    auth.onAuthStateChanged((user) => {
      if (!user || user?.isAnonymous) {
        // No real user signed in.
        console.log("File: Subscription.vue, user not signed in. Loads login.");
        this.isUserLoggedIn = false;
        this.$router.push({ name: "Login" });
      } else if (typeof sessionStorage.organizationId === "undefined") {
        this.$router.push({ name: "Login" });
      } else {
        this.isUserLoggedIn = true;
      }
    });
    // if (!user && !user?.isAnonymous) {
    //   console.log("File: Subscription.vue, in if check");
    //   this.$router.push({ name: "Login" });
    // }
    // this.$watch(
    //   () => this.$store.state.organizationId,
    //   () => {
    //     this.reload = true;
    //     setTimeout(() => {
    //       this.reload = false;
    //     }, 10);
    //   }
    // );
  },
  computed: {
    ...mapState({
      subscriptionDetails: (state) => state.subscriptionDetails,
    }),
  },
};
</script>
